import { path, pathOr } from 'ramda';

import type { Notification } from '@frontend/api/src/notifications/types';
import { Text, Box } from '@frontend/legacy-components';

import { InteractiveFlex } from 'components/lib2/InteractiveContainers';

import NotificationDateAndBusinessName from './NotificationDateAndBusinessName';
import NotificationThumbnail from './NotificationThumbnail';
import ToastCloseButton from './ToastCloseButton';

const NotificationToast = ({
  notification,
  isThumbnail,
  onClose,
  thumbnailBlob,
}: {
  notification: Notification;
  isThumbnail: boolean;
  onClose: () => void;
  thumbnailBlob?: Blob | null;
}) => {
  const pathToResource = notification?.relativeUrl || '';

  let title = pathOr(false, ['title'], notification)
    ? `${path(['title'], notification)}: `
    : '';

  const msg = pathOr(false, ['body'], notification)
    ? `${path(['body'], notification)}`
    : '';

  if (!msg) title = title.slice(0, -2);

  const handleClose = (e: React.MouseEvent<Element, MouseEvent>) => {
    e.preventDefault();
    e.stopPropagation();

    onClose();
  };

  return (
    <Box
      marginBottom={2}
      border="1px solid"
      borderColor="separator.border"
      borderRadius="md"
    >
      <InteractiveFlex
        justifyContent="space-between"
        padding={2}
        paddingRight={4}
        as={'a'}
        href={pathToResource}
      >
        <Box
          marginRight={1}
          display="flex"
          flexDirection="column"
          flex={1}
          minWidth={0}
        >
          <Text fontWeight="heavy" size="sm">
            {title}
          </Text>
          {msg && <Text size="sm">{msg}</Text>}
          <NotificationDateAndBusinessName notification={notification} />
        </Box>
        {isThumbnail && (
          <NotificationThumbnail
            notification={notification}
            thumbnailBlob={thumbnailBlob}
          />
        )}
      </InteractiveFlex>
      <ToastCloseButton handleClose={handleClose} />
    </Box>
  );
};

export default NotificationToast;
